import React from 'react'
import styled from '@emotion/styled'
import {RadioCircle} from '../../accountManagement/shared/RadioCircle'
import {theme} from '../../accountManagement/theme'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2]};
`

const Question = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
`

const OptionsRow = styled.div`
  display: flex;
  gap: ${theme.space[4]};
`

const Option = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[1.5]};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.primary};
`

function IncludeOnboardingToggle({includeOnboarding, setIncludeOnboarding}) {
  const selectedValue = includeOnboarding?.value ?? includeOnboarding

  return (
    <Wrapper>
      <Question>Include Onboarding?</Question>
      <OptionsRow>
        <Option
          type="button"
          onClick={() =>
            setIncludeOnboarding(prev => ({...prev, value: 'Yes'}))
          }
        >
          <RadioCircle active={selectedValue === 'Yes'} variant="dot" />
          Yes
        </Option>
        <Option
          type="button"
          onClick={() => setIncludeOnboarding(prev => ({...prev, value: 'No'}))}
        >
          <RadioCircle active={selectedValue === 'No'} variant="dot" />
          No
        </Option>
      </OptionsRow>
    </Wrapper>
  )
}

export {IncludeOnboardingToggle}
